<ion-app>
  <!--
    The sidebar body. Built from plain elements rather than ion-menu/ion-item to
    avoid their lifecycle quirks in this layout.
  -->
  <ng-template #menuBody>
    <div class="menu-shell">
      <!--
        Two images, one shown at a time. Collapsed, the rail is ~64px wide and a
        wordmark squeezed into that is an illegible smear — so the mark takes
        over, which is what a mark is for.
      -->
      <div class="menu-header">
        <img src="/assets/icon/haiplay-logo.png" alt="HAI Play" class="logo logo--wordmark">
        <img src="/assets/icon/haiplay-mark.png" alt="HAI Play" class="logo logo--mark">
      </div>

      <!-- The primary action lives at the top: uploading a match is what the
           product is for, and burying it in a list makes it look optional. -->
      <a class="menu-cta" routerLink="/videos/upload" (click)="onMenuItemClick()" [title]="'Upload match' | translate">
        <ion-icon name="add"></ion-icon>
        <span class="menu-item__label">{{ 'Upload match' | translate }}</span>
      </a>

      <!--
        Only ever here once the new build is already downloaded, so the click is a
        reload and not a wait. Above the nav because it is time-sensitive and the
        nav is not; below the CTA because uploading still outranks it.
      -->
      <button type="button" class="update-banner" *ngIf="core.versionService.updateable$|async"
              (click)="updateApp()" [title]="'New version available — click to update' | translate">
        <span class="update-banner__icon-wrapper">
          <ion-icon name="sparkles-outline" aria-hidden="true"></ion-icon>
        </span>
        <span class="update-banner__text">
          <span class="update-banner__title">{{ 'New version available' | translate }}</span>
          <span class="update-banner__subtitle">{{ 'Click to update' | translate }}</span>
        </span>
        <ion-icon class="update-banner__chevron" name="arrow-forward-outline" aria-hidden="true"></ion-icon>
      </button>

      <nav class="menu-nav">
        @for (section of menuSections; track section.title) {
        <div class="menu-section">
          <span class="menu-section__title">{{ section.title | translate }}</span>
          @for (p of section.pages; track p.url) {
          <a class="menu-item" [routerLink]="[p.url]" routerLinkActive="selected" (click)="onMenuItemClick()" [title]="p.title | translate">
            <ion-icon class="menu-item__icon" aria-hidden="true" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
            <span class="menu-item__label">{{ p.title | translate }}</span>
            <!-- Visible even when collapsed: it is the only label left. -->
            <span class="menu-item__badge" *ngIf="p.badge && p.badge() as count">{{ count }}</span>
          </a>
          }
        </div>
        }
      </nav>

      <button type="button" class="collapse-toggle" (click)="toggleCollapsed()"
              [attr.aria-label]="(collapsed$|async) ? ('Expand sidebar' | translate) : ('Collapse sidebar' | translate)"
              [title]="(collapsed$|async) ? ('Expand' | translate) : ('Collapse' | translate)">
        <!-- The arrow says it. A row labelled "Collapse" sitting under the menu
             reads as one more destination rather than a control of the menu. -->
        <ion-icon [name]="(collapsed$|async) ? 'chevron-forward-outline' : 'chevron-back-outline'"></ion-icon>
      </button>

      <!--
        Whose product this is, and the terms that govern it. Both point at
        handball.ai — the legal texts live there, and a copy maintained here
        would be a second version of them to keep in step.
      -->
      <div class="app-version">
        <!--
          The `<strong>` is inside the key rather than around it. Splitting the
          sentence into "A" + markup + "product" would only ever reassemble in
          English word order, and lifting the tag out would colour the whole
          line instead of the brand. Angular's sanitiser passes `<strong>`.
        -->
        <a class="maker" href="https://handball.ai" target="_blank" rel="noopener"
           [innerHTML]="'A <strong>handball.ai</strong> product' | translate"></a>
        <div class="legal">
          <a href="https://handball.ai/terms" target="_blank" rel="noopener">{{ 'Terms' | translate }}</a>
          <span aria-hidden="true">·</span>
          <a href="https://handball.ai/privacy" target="_blank" rel="noopener">{{ 'Privacy' | translate }}</a>
        </div>
        <small>&copy; HAI Play v{{core.version}}</small>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="(core.appIsReady$|async)===true">
    <div class="app-shell">
      <!-- Always present; collapses to an icon strip rather than disappearing. -->
      <aside class="permanent-sidebar" [class.collapsed]="(collapsed$|async)" *ngIf="(showMenu$|async)">
        <ng-container *ngTemplateOutlet="menuBody"></ng-container>
      </aside>

      <ion-router-outlet id="main-content"></ion-router-outlet>
    </div>

  </ng-container>

  <div *ngIf="(core.appIsReady$|async)===false || (core.appIsReady$|async)==='error'" class="loading-page">
    <img src="/assets/icon/haiplay-logo.png" alt="HAI Play" class="logo">
    <ion-spinner name="lines-small" *ngIf="(core.appIsReady$|async)===false"></ion-spinner>
    <ion-text *ngIf="(core.appIsReady$|async)==='error'" color="danger">{{ 'Error initializing app. Check for updates or contact support.' | translate }}</ion-text>
  </div>
</ion-app>
